import { render } from "./404View.vue?vue&type=template&id=fc3dfef0&scoped=true"
import script from "./404View.vue?vue&type=script&lang=js"
export * from "./404View.vue?vue&type=script&lang=js"

import "./404View.vue?vue&type=style&index=0&id=fc3dfef0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3dfef0"]])

export default __exports__